module.exports = __webpack_public_path__ + "908e4d2e/img/archive-icon.0a6a9de3.svg";